import { match } from 'ts-pattern';
import { Tag } from '../../../atoms/tag/tag';
import { ComponentProps, useMemo } from 'react';

type CustomerStatusProps = {
  label: string;
  status: 'active' | 'inactive' | 'prospect';
};

export function CustomerStatus(props: CustomerStatusProps) {
  const { label, status } = props;

  const mappedStatus = useMemo(
    () => mapCustomerStatusToTagStatus(status),
    [status],
  );

  if (mappedStatus === null) {
    return null;
  }

  return <Tag label={label} variant={mappedStatus} />;
}

type TagStatus = ComponentProps<typeof Tag>['variant'];

function mapCustomerStatusToTagStatus(
  status: CustomerStatusProps['status'],
): TagStatus {
  return match(status)
    .returnType<TagStatus>()
    .with('active', () => 'success')
    .with('inactive', () => 'inactive')
    .with('prospect', () => 'default')
    .otherwise(() => null);
}
